<div class="flex flex-col gap-1" data-test-class="filter-group">
	<span [id]="groupName() + '-label'" class="font-semibold">
		{{ 'compositions.filters.type.' + title() + '.label' | translate }}
	</span>
	<div
		[attr.aria-labelledby]="groupName() + '-label'"
		class="flex flex-col gap-3"
		role="group"
	>
		@for (filterItem of options(); track filterItem.value) {
			<div class="flex flex-row">
				<vp-checkbox
					[disabled]="filterItem.disabled"
					[initialValue]="activeValues().includes(filterItem.value)"
					[inputId]="groupName() + '-' + filterItem.value"
					(emittedValue)="onToggle(filterItem.value, $event)"
					class="w-full"
				>
					{{ filterItem.name }}
				</vp-checkbox>
				<span
					[class]="cn(filterItem.disabled && 'text-dark-quaternary')"
				>
					{{ filterItem.frequency }}
				</span>
			</div>
		}
		@if (collapsible.hasMoreItems()) {
			<button
				(click)="collapsible.showMore()"
				class="w-fit underline"
				data-test-class="show-more"
			>
				{{ 'global.show-more' | translate }}
			</button>
		}
	</div>
</div>
